import { SprievodnyDokumentExistsApi, SprievodnyDokumentStatus } from 'evidencna-aplikacia-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import { evidenciaPrefixPath } from '../configuration/apiConfigurationConstants';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';

const client = new SprievodnyDokumentExistsApi(apiConfiguration(evidenciaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const existsSprievodnyDokument = async (
  uuid: string,
  kod: string,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<SprievodnyDokumentStatus>> => {
  const {
    data,
    status,
  } = await client.existSprievodnyDokument(
    uuid,
    kod,
    options,
  );
  return {
    data,
    responseCode: status,
  };
};

// eslint-disable-next-line import/prefer-default-export
export const existsSprievodnyDokumentInAnyStadium = async (
  legMaterialUuid: Uuid,
  kod: string,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<SprievodnyDokumentStatus>> => {
  const {
    data,
    status,
  } = await client.existSprievodnyDokumentInAnyStadium(
    legMaterialUuid.toString(),
    kod,
    options,
  );
  return {
    data,
    responseCode: status,
  };
};
